export class ApiServiceRequestDatos {
    public Namespace: string;
    public Clase: string;
    public Metodo: string;
    public Parametros: any;

    constructor(Clase: string, Metodo: string, Parametros: any = {}) {
        this.Namespace = process.env.REACT_APP_API_NAMESPACE || "";
        this.Clase = Clase;
        this.Metodo = Metodo;
        this.Parametros = Parametros;
    };
};

export class ApiServiceRequest {
    public Token: string;
    public CodigoCliente: string;
    public Usuario: string;
    public Contraseña: string;
    public Servidor: string;
    public Catalogo: string;
    public ClaveActivacion: string;
    public Datos: ApiServiceRequestDatos;
    public VersionSO: number;
    public CodIdioma: string;
    public VersionApp: string;
    public VersionSONum: string;

    constructor(Datos: ApiServiceRequestDatos, Usuario: string, Contraseña: string = "", CodigoCliente: string = "", Token: string = "", Android: boolean = false) {
        this.Token = Token;
        this.CodigoCliente = CodigoCliente;
        this.Usuario = Usuario;
        this.Contraseña = Contraseña;
        this.Servidor = "";
        this.Catalogo = "";
        this.ClaveActivacion = "";
        this.Datos = Datos;
        this.VersionSO = Android ? parseInt(process.env.REACT_APP_API_VERSION_SO_ANDROID || "0") : parseInt(process.env.REACT_APP_API_VERSION_SO || "0");
        this.CodIdioma = process.env.REACT_APP_API_LANGUAGE || "ES-ES";
        this.VersionApp = process.env.REACT_APP_API_VERSION_APP || "1.0.0";
        this.VersionSONum = "";
    };
};
